import { render, staticRenderFns } from "./healthrecords.vue?vue&type=template&id=7ec7cc54&"
import script from "./healthrecords.vue?vue&type=script&lang=js&"
export * from "./healthrecords.vue?vue&type=script&lang=js&"
import style0 from "./healthrecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports